import {decorate, observable} from 'mobx';
import {faRepeat} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';

export class Phase extends BaseModel {
  static faIcon = faRepeat;

  searchableProperties = ['name'];

  static prepareApiPayload(model) {
    return {
      ...model,
      sortOrder: Number.isFinite(Number.parseInt(model.sortOrder, 10)) ? model.sortOrder : null,
    };
  }
}

decorate(Phase, {
  id: observable,
  name: observable,
  description: observable,
  groupName: observable,
  sortOrder: observable,
});
